import React, { useState, useRef } from "react";
import { injectModels } from "../../redux/injectModels";
import FormData from "form-data";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Routes } from "../../constants";

const FormVideoSop = (props) => {
  const buttonRef = useRef(null);
  const navigate = useNavigate();
  const [companyName, setcompanyName] = useState("");
  const [companyNameError, setcompanyNameError] = useState("");
  const [title, setTitle] = useState("");
  const [titleError, setTitleError] = useState("");
  const [jobProfile, setjobProfile] = useState("");
  const [jobProfileError, setjobProfileError] = useState("");
  const [department, setDepartment] = useState("");
  const [departmentError, setDepartmentError] = useState("");

  const handleTitle = (event) => {
    const input = event.target.value;
    if (input === "" || input === null) {
      setTitleError("Title is required!");
    } else {
      setTitleError("");
    }
    setTitle(input);
  };
  const handlecompanyName = (event) => {
    const input = event.target.value;
    if (input === "" || input === null) {
      setcompanyNameError("Company Name is required!");
    } else {
      setcompanyNameError("");
    }
    setcompanyName(input);
  };

  const handlejobProfile = (event) => {
    const input = event.target.value;
    if (input === "" || input === null) {
      setjobProfileError("Job Profile is required!");
    } else {
      setjobProfileError("");
    }
    setjobProfile(input);
  };
  const handleDepartment = (event) => {
    const input = event.target.value;
    if (input === "" || input === null) {
      setDepartmentError("Department is required!");
    } else {
      setDepartmentError("");
    }
    setDepartment(input);
  };

  const handleReset = () => {
    setTitle("");
    setcompanyName("");
    setjobProfile("");
    setDepartment("");
    setTitleError("");
    setDepartmentError("");
    setjobProfileError("");
    setcompanyNameError("");
  };

  // Function to send audio to the backend
  const handleSend = async (event) => {
    event.preventDefault();

    if (!title) {
      setTitleError("Title is required!.");
      return;
    }
    if (!companyName) {
      setcompanyNameError("Company Name is required!");
      return;
    }
    if (!jobProfile) {
      setjobProfile("Job Profile is required!");
      return;
    }
    if (!department) {
      setDepartment("Department is required!");
      return;
    }

    const formData = new FormData();
    formData.append("title", title);
    formData.append("job_profile", jobProfile);
    formData.append("company_name", companyName);
    formData.append("department", department);

    try {
      props.application.setLoading(true);
      const response = await props.admin.createVideoSession(formData);
      if (response) {
        props.application.setLoading(false);
        toast.success(response.message, {
          position: toast.POSITION.TOP_CENTER,
        });
        const button = buttonRef.current;
        if (button) {
          button.click();
        }
        setcompanyName("");
        setjobProfile("");
        setDepartment("");
        navigate(Routes.CREATE_VIDEO_Sop, {
          state: response.data.video_session_id,
        });
      } else {
        props.application.setLoading(false);
        toast.error(response.message, {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      props.application.setLoading(false);
      console.error("Error :", error);
      toast.error("An error occurred while creating the video.");
    }
  };

  return (
    <div className="modal fade" id="largeModal" tabIndex="-1">
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Create Video </h5>
            <button
              ref={buttonRef}
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              onClick={handleReset}
            ></button>
          </div>
          <div className="modal-body">
            <form className="row g-3 p-2" onSubmit={handleSend}>
              <div className="col-md-12 mt-1"></div>

              <div className="col-md-6">
                <label htmlFor="" className="form-label">
                  Title<span style={{color:"red"}}>*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${titleError ? "error-border" : ""}`}
                  id=""
                  value={title}
                  placeholder="Enter title"
                  onChange={handleTitle}
                  maxLength={250}
                />
                {titleError && <div className="text-danger">{titleError}</div>}
              </div>
              <div className="col-md-6">
                <label htmlFor="" className="form-label">
                  Company Name<span style={{color:"red"}}>*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${companyNameError ? "error-border" : ""}`}
                  id=""
                  value={companyName}
                  placeholder="Enter company name"
                  onChange={handlecompanyName}
                  maxLength={250}
                />
                {companyNameError && (
                  <div className="text-danger">{companyNameError}</div>
                )}
              </div>
              <div className="col-md-6">
                <label htmlFor="" className="form-label">
                  Job profile<span style={{color:"red"}}>*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${jobProfileError ? "error-border" : ""}`}
                  id=""
                  value={jobProfile}
                  placeholder="Enter job profile"
                  onChange={handlejobProfile}
                  maxLength={250}
                />
                {jobProfileError && (
                  <div className="text-danger">{jobProfileError}</div>
                )}
              </div>
              <div className="col-md-6">
                <label htmlFor="" className="form-label">
                  Department<span style={{color:"red"}}>*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${departmentError ? "error-border" : ""}`}
                  id=""
                  value={department}
                   placeholder="Enter department"
                  onChange={handleDepartment}
                  maxLength={250}
                />
                {departmentError && (
                  <div className="text-danger">{departmentError}</div>
                )}
              </div>

              <div className="mbtn-row">
                <button
                  type="button"
                  className="btn btn-secondary m-0"
                  onClick={handleReset}
                >
                  Reset
                </button>
                <button type="submit" className="btn btn-primary m-0">
                  Create
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
export default injectModels(["admin", "application"])(FormVideoSop);
